import { render } from "./EtcPriceUpdate.vue?vue&type=template&id=5b6f106e"
import script from "./EtcPriceUpdate.vue?vue&type=script&lang=js"
export * from "./EtcPriceUpdate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__